export default __webpack_public_path__ + "static/media/img13.47b653fb.jpg";